import React, { useRef, useState, useEffect } from "react";
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { Grid} from '@mui/joy';
import CategorySlider from "../Slider/index.jsx";
import { Button, Typography } from "@mui/material";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import styles from './styles.js';
import { createTheme } from '@mui/system';
// import { emulatorScreen, mobileScreen } from '../../../utils/index.js';
const theme = createTheme();


const Question = (props) => {
  // console.log("[emulatorScreen(theme)]", [mobileScreen(theme)])
  const [p0, setP0] = useState(10)
  const [p1, setP1] = useState(10)
  const [p2, setP2] = useState(10)
  const [p3, setP3] = useState(10)
  const [p7, setP7] = useState(10)
  // const [extra, setExtra] = useState(0)
  const [errorDisplay, setErrorDisplay] = useState("")
  const [percentage, setPercentage] = useState(50)
  const [percentageColor, setPercentageColor] = useState("red")
  const { setCurrentScreen, setAnswers, question } = props
  const { Title, GraphHeading, QuestionMarkers, TotalText, PercentageText, Number, SubmmitButton, LeftGrid } = styles
  const data = [
    { id: 0, value: p0, color: "#54AFD3", cusLabel: "Top", label: 'Top' },
    { id: 1, value: p1, color: "#77DB93", cusLabel: "Second", label: 'Second' },
    { id: 2, value: p2, color: "#AEC6CF", cusLabel: "Bottom", label: 'Bottom' },
    { id: 4, value: p3, color: "#838BDA", cusLabel: "Middle", label: 'Middle' },
    // { id: 3, value: p4, color: "#8AC7D8", cusLabel: "Interest on Debt", label: 'Other' },
    // { id: 5, value: p5, color: "#FF796F", cusLabel: "Veteran's Benefits", label: "Veteran's Benefits" },
    // { id: 6, value: p6, color: "#00FFFF", cusLabel: "Education", label: 'Education,Training\n Services' },
    { id: 7, value: p7, color: "#5186EA", cusLabel: "Fourth", label: 'Fourth' },
    // { id: 8, value: extra, color: "#808080", cusLabel: "Extra", label: 'Extra' },
  ]
  const [style, setStyle] = useState({ height: 550 });

  const mobileScreen = theme => '(max-width: 900.95px) and (max-height: 440px)';
  const emulatorScreen = theme => '(max-width: 1200px)';

  useEffect(() => {
    const applyInitialStyles = () => {
      const mobileScreenQuery = mobileScreen(theme);
      const emulatorScreenQuery = emulatorScreen(theme);

      if (window.matchMedia(mobileScreenQuery).matches) {
        setStyle({ height: 240, labelFont: 10, innerRadius: 15, outerRadius: 100 })
      }else if (window.matchMedia(emulatorScreenQuery).matches) {
        setStyle({ height: 450,  width: 450, labelFont: 12, innerRadius: 60, outerRadius: 150 });
      } else {
        setStyle({ height: 550, width: 550, labelFont: 14, innerRadius: 80, outerRadius: 250 })
      }
    };
    applyInitialStyles(); // Apply styles once on component mount
  }, [theme]);

  const TOTAL = data.map((item) => item.value).reduce((a, b) => a + b, 0);

  const getArcLabel = (params) => {
    const percent = params.value / TOTAL;
    if (percent < 0.01) {
      return null;
    }
    // console.log(p0)
    return `${params.cusLabel} ${params.value.toFixed(0)}%`;
  };

  const pieChart = () => {
    return (<PieChart
      series={[
        {
          data: data,
          innerRadius: style.innerRadius,
          outerRadius: style.outerRadius,
          arcLabel: getArcLabel
        },
      ]}
      margin={{left: 100}}
      height={style.height}
      slotProps={{
        legend: {
          hidden: true,
          direction: 'row',
          // position: { vertical: 'middle', horizontal: 'right' },
          // padding: 0,
          // itemGap: 15
        },
      }}
      sx={{
        [`& .${pieArcLabelClasses.root}`]: {
          fill: '#404040',
          fontSize: style.labelFont,
          fontFamily: "Rubik"
          // textAnchor:'middle',
          // transform: 'translate(0, -50%)',
        },
      }}
    />)
  }

  useEffect(() => {
    setPercentageColor(percentage == 100 ? "green" : "red")
  }, [percentage])

  const allowChange = (change) => {
    setPercentage(percentage + change)
    return true
    // if(p0 + p1 + p2 + p3 + p4 + p5 + p7 + change <= 100) {
    //   // setExtra(extra - change)
    //   setErrorDisplay("")
    //   return true
    // }
    // else {
    //   setErrorDisplay("Total should be between 0 and 100")
    //   return false
    // }
  }

  const submitAnswer = () => {
    setAnswers({
      Top: p0,
      Second: p1,
      Bottom: p2,
      Middle: p3,
      Fourth: p7,
    })
    setCurrentScreen("Answer")
  }

  const remaingPercentage =() => {
    let diff = percentage - 100
    return diff > 0 ? `+${diff}` : diff
  }

  const toltipComponent = () => {
    return(
    <Grid style={{ width: 300, backgroundColor: 'red', padding: 10, margin: "-5px -10px", borderRadius: 10 }}>
      { percentage < 100 ?
        <Typography style={{  display: "flex", fontSize: 22 }} >Your total is too low. It must add up to 100%.</Typography>
      : percentage > 100 ?
        <Typography style={{  display: "flex", fontSize: 22 }}>Your total is too high. It must add up to 100%.</Typography>
        : null
      }
    </Grid>
    )
  }

  return(
    <Grid container alignItems={'center'} justifyContent={'center'} padding={0}>
      {/* <Typography color={'red'} padding={1} align="center" height={30}>{errorDisplay}</Typography> */}
      <LeftGrid container spacing={2} xs={12} justifyContent={'center'}>
        <Grid container xs={5} md={5}>
          <Title>Make a guess</Title>
          <CategorySlider setValue={setP0} value={p0} color={"#54AFD3"} allowChange={allowChange} tooltipText={question.tooltip["Top"]} name={"Top 20% of earners"} />
          <CategorySlider setValue={setP1} value={p1} color={"#77DB93"} allowChange={allowChange} tooltipText={question.tooltip["Second"]} name={"Second 20% of earners"} />
          <CategorySlider setValue={setP3} value={p3} color={"#AEC6CF"} allowChange={allowChange} tooltipText={question.tooltip["Middle"]} name={"Middle 20% of earners"} />
          <CategorySlider setValue={setP7} value={p7} color={"#838BDA"} allowChange={allowChange} tooltipText={question.tooltip["Fourth"]} name={"Fourth 20% of earners"} />
          <CategorySlider setValue={setP2} value={p2} color={"#5186EA"} allowChange={allowChange} tooltipText={question.tooltip["Bottom"]} name={"Bottom 20% of earners"} />
        </Grid>
        <Grid container xs={6} justifyContent={'center'}>
          <GraphHeading>
          {question.title}
            <Tooltip title="What share of federal incomes tax is paid by each income group? Source: Tax Policy Center (Urban Institute and Brookings Institution)">
              <IconButton>
                <QuestionMarkers />
              </IconButton>
            </Tooltip>
          </GraphHeading>
          <Grid container xs={12} justifyContent={'center'}>
            {pieChart()}
          </Grid>
        </Grid>
      </LeftGrid>
      <Grid container xs={12} justifyContent={"space-evenly"}>
        <Grid container justifyContent={'center'} alignItems={'center'} style={{ width: "33%" }}>
          <TotalText>Total: </TotalText>
          <PercentageText> {percentage}% </PercentageText>
          <Number style={{ color: percentageColor }}> ({remaingPercentage()}%) </Number>
        </Grid>
        <Tooltip title={toltipComponent()} disableHoverListener={percentage == 100} placement={'top'}>
          <SubmmitButton style={{ backgroundColor: percentage !== 100 ? "grey" : "#00b1d9" }}
          onClick={() =>  percentage == 100 && submitAnswer()}
          className={`${percentage == 100 && "animate__animated animate__bounceIn"}`}
          >
            SUBMIT
          </SubmmitButton>
        </Tooltip>
        <Grid style={{ width: "33%" }}></Grid>
      </Grid>
    </Grid>
  )
}

// Use it if you don't plan to use "remount"
// document.addEventListener('DOMContentLoaded', () => {
  // ReactDOM.render(, document.getElementById('hello'))
// })

export default Question
